import { Button, Heading } from '@clayui/core';
import ClayLayout from '@clayui/layout';
import React from 'react';
import SubmitButton from '../../generic-components/button/FormButton';
import { useDispatch } from 'react-redux';
import { resetForm } from '../../slices/businessExpansionSlice';
import { primaryButtonStyle, scrollToSection } from '../../utils/commonUtil';
import { resetPitchForm } from '../../slices/pitchFormSlice';

const FinalScreen: React.FC<{
    setStep: React.Dispatch<React.SetStateAction<number>>;
    resStatusMessage: string;
    resStatusCode: number;
}> = ({ setStep, resStatusMessage, resStatusCode }) => {
    const dispatch = useDispatch();
    const handleSubmit = () => {
        dispatch(resetForm());
        dispatch(resetPitchForm());
        setStep(0);
        window.location.reload();
        scrollToSection();
    };

    return (
        <>
            {resStatusCode == 200 ? (
                <>
                    <ClayLayout.ContentSection className="final_screen">
                        <ClayLayout.ContentSection className="done_icon">
                            <span className="material-symbols-rounded">
                                check
                            </span>
                        </ClayLayout.ContentSection>
                        <div style={{ color: '#76bc21' }}>
                            <Heading level={1} weight="bold" fontSize={6}>
                                Great !
                            </Heading>
                            <Heading level={6} weight="normal" fontSize={5}>
                                {resStatusMessage ??
                                    'Your Inquiry has been submitted successfully.'}
                            </Heading>
                        </div>

                        <div className="button_container">
                            {/* <SubmitButton label="Done" onClick={handleSubmit} /> */}
                            <Button
                                type="button"
                                onClick={handleSubmit}
                                className="bottom-cut"
                                style={primaryButtonStyle}
                            >
                                <span className="bottom-cut-span"></span>
                                Done
                            </Button>
                        </div>
                    </ClayLayout.ContentSection>
                </>
            ) : (
                <ClayLayout.ContentSection className="final_screen">
                    <div className="error_icon">
                        <svg
                            width="51"
                            height="51"
                            viewBox="0 0 71 71"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M35.4997 0.5C54.8264 0.5 70.4999 16.1735 70.4999 35.5002C70.4999 54.8269 54.8264 70.5004 35.4997 70.5004C16.173 70.5004 0.499512 54.8269 0.499512 35.5002C0.499512 16.1735 16.173 0.5 35.4997 0.5ZM31.75 38.512V20.4978C31.75 18.4327 33.4346 16.7481 35.4997 16.7481C37.5649 16.7481 39.2494 18.4483 39.2494 20.4978V38.512C39.2494 40.5615 37.5649 42.2617 35.4997 42.2617C33.4346 42.2617 31.75 40.5771 31.75 38.512ZM35.4835 46.2834C37.8303 46.2834 39.7337 48.1867 39.7337 50.5333C39.7337 52.8801 37.8303 54.7835 35.4835 54.7835C33.137 54.7835 31.2336 52.8801 31.2336 50.5333C31.2336 48.1867 33.137 46.2834 35.4835 46.2834Z"
                                fill="#F9F9F9"
                            />
                        </svg>
                    </div>
                    <div
                        className="error-section mt-5"
                        style={{ color: '#DA1414', textAlign: 'center' }}
                    >
                        <Heading level={1} weight="bold" fontSize={6}>
                            Sorry!
                        </Heading>
                        <Heading level={6} weight="normal" fontSize={5}>
                            {resStatusMessage}
                        </Heading>
                        <div className="button_container">
                            <Button
                                type="button"
                                onClick={handleSubmit}
                                className="bottom-cut"
                                style={primaryButtonStyle}
                            >
                                <span className="bottom-cut-span"></span>
                                Done
                            </Button>
                        </div>
                    </div>
                </ClayLayout.ContentSection>
            )}
        </>
    );
};

export default FinalScreen;
